import React from 'react';
import Logo from '../components/common/Logo';
import { Star, Calendar, ThumbsUp } from 'lucide-react';
import DoctorSidebar from '../components/dashboard-doctor/DoctorSidebar';

const DoctorFeedbackPage = () => {
  // Dati di esempio dei feedback
  const feedbacks = [
    {
      patientName: "Mario R.",
      rating: 5,
      comment: "La Dott.ssa è stata molto professionale e empatica. Mi ha aiutato a superare un momento difficile con grande competenza.",
      date: "10 Novembre 2024",
      serviceType: "Psicoterapia",
      sessionCount: 8,
      helpful: 3
    },
    {
      patientName: "Laura B.",
      rating: 4,
      comment: "Ottimo percorso terapeutico, ambiente confortevole e grande professionalità.",
      date: "5 Novembre 2024",
      serviceType: "Consulenza Psicologica",
      sessionCount: 3,
      helpful: 1
    },
    // Altri feedback...
  ];

  const stats = {
    totalFeedback: 45,
    averageRating: 4.8,
    totalSessions: 156
  };

  return (
    <div className="flex min-h-screen">
      <div className="w-64 bg-white shadow-md">
        <div className="p-4">
          <Logo />
        </div>
        <DoctorSidebar />
      </div>

      <div className="flex-1 bg-[#FAF4EB] p-8">
        <header className="mb-8">
          <h1 className="text-2xl font-bold">Feedback Ricevuti</h1>
          <p className="text-gray-600">Gestisci e analizza i feedback dei tuoi pazienti</p>
        </header>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-600">Media Valutazioni</p>
                <p className="text-2xl font-bold">{stats.averageRating}/5</p>
              </div>
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className={`w-5 h-5 ${
                      i < Math.floor(stats.averageRating)
                        ? 'text-yellow-400 fill-current'
                        : 'text-gray-300'
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-md">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-600">Feedback Totali</p>
                <p className="text-2xl font-bold">{stats.totalFeedback}</p>
              </div>
              <ThumbsUp className="w-8 h-8 text-purple-600" />
            </div>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-md">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-600">Sessioni Totali</p>
                <p className="text-2xl font-bold">{stats.totalSessions}</p>
              </div>
              <Calendar className="w-8 h-8 text-purple-600" />
            </div>
          </div>
        </div>

        {/* Feedback List */}
        <div className="bg-white rounded-lg shadow-md">
          {feedbacks.map((feedback, index) => (
            <div
              key={index}
              className={`p-6 ${
                index !== feedbacks.length - 1 ? 'border-b' : ''
              }`}
            >
              <div className="flex justify-between items-start mb-4">
                <div>
                  <h3 className="font-semibold">{feedback.patientName}</h3>
                  <div className="flex items-center mt-1">
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        className={`w-4 h-4 ${
                          i < feedback.rating
                            ? 'text-yellow-400 fill-current'
                            : 'text-gray-300'
                        }`}
                      />
                    ))}
                    <span className="text-sm text-gray-600 ml-2">
                      {feedback.date}
                    </span>
                  </div>
                </div>
                <div className="text-right text-sm text-gray-600">
                  <p>{feedback.serviceType}</p>
                  <p>{feedback.sessionCount} sessioni</p>
                </div>
              </div>
              <p className="text-gray-700 mb-3">{feedback.comment}</p>
              <div className="flex items-center text-sm text-gray-600">
                <ThumbsUp className="w-4 h-4 mr-1" />
                <span>{feedback.helpful} persone hanno trovato utile questa recensione</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DoctorFeedbackPage;